import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './checkbox.magic.css.js';
import script from './checkbox.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",class:[{
        'checkbox--inline': _vm.inline,
        'checkbox--no-label': _vm.noLabel,
        'checkbox--no-margin': _vm.noMargin,
        'has-error': _vm.hasError,
    }],attrs:{"part":_vm.$p('checkbox', [{
        'checkbox--inline': _vm.inline,
        'checkbox--no-label': _vm.noLabel,
        'checkbox--no-margin': _vm.noMargin,
        'has-error': _vm.hasError,
    }])}},[_c('input',_vm._b({staticClass:"input",attrs:{"part":"input","type":"checkbox","id":_vm.$attrs.id || 'checkbox'},domProps:{"checked":_vm.value,"indeterminate":_vm.indeterminate},on:{"change":function($event){$event.stopPropagation();return _vm.handleChange($event)}}},'input',_vm.$filteredAttrs,false)),_vm._v(" "),_c('label',{staticClass:"label",class:{ 'label--bold': _vm.bold },attrs:{"part":_vm.$p('label', { 'label--bold': _vm.bold }),"for":_vm.$attrs.id || 'checkbox'}},[_vm._t("default")],2)])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-82c6534e_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-82c6534e";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
